import { Injector, Injectable } from '@angular/core';
import { ReportParamsTransformer } from '@content-platform/web-angular-shared-util-error-handling';
import { Store, select } from '@ngrx/store';
import { getADUser } from './auth/auth.selectors';
import * as i0 from "@angular/core";
export class AuthReportTransformer extends ReportParamsTransformer {
    constructor(injector) {
        super(injector);
        this.injector = injector;
        this.subscriptions = [];
    }
    initialize() {
        const store = this.injector.get(Store);
        this.subscriptions.push(store.pipe(select(getADUser)).subscribe((user) => (this.user = user)));
    }
    getParams() {
        return {
            'User Name': this.user ? this.user.userName : undefined
        };
    }
    ngOnDestroy() {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
    static { this.ɵfac = function AuthReportTransformer_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AuthReportTransformer)(i0.ɵɵinject(i0.Injector)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AuthReportTransformer, factory: AuthReportTransformer.ɵfac }); }
}
//# sourceMappingURL=auth-report-transformer.js.map